import React, { useEffect, useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import routes from 'app/routes';
import { useContext as useUsersContext } from 'components/Users/Context';

import EditTimeZone from 'components/Members/Profile/MemberInfo/Edit/TimeZone';
import List from './Views/List/Index';
import New from './Views/New/Index';
import Summary from './Views/Summary/Index';

import BuyOrSkip from './Views/BuyOrSkip/Index';
import ZoomInfo from './Views/ZoomInfo/Index';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  const [refreshKey, setRefreshKey] = useState(0);

  const refreshParent = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  const router = createBrowserRouter([
    {
      path: routes.members.schedule.index,
      element: <List key={refreshKey} />,
      children: [
        {
          path: routes.members.steps.buyOrSkip(),
          element: <BuyOrSkip key="list-skip" refreshParent={refreshParent} />,
        },
        {
          path: routes.members.steps.zoomInfo(),
          element: <ZoomInfo />,
        },
      ],
    },
    {
      path: routes.members.steps.schedule(),
      element: <New key={refreshKey} />,
      children: [
        {
          path: routes.members.steps.timezone(),
          element: <EditTimeZone refreshParent={refreshParent} />,
        },
        {
          path: routes.members.steps.buyOrSkipSchedule(),
          element: <BuyOrSkip key="session-skip" />,
        },
      ],
    },
    {
      path: routes.members.steps.scheduleSummary(),
      element: <Summary />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}
